'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'

import { getBrandName } from '@/src/utils/buildUtils'

import { MobileAppPromotion } from './mobileAppPromotion'

interface MobileAppPromotionWrapperProps {
    verticalLayout?: boolean
}

const MobileAppPromotionWrapper: React.FC<MobileAppPromotionWrapperProps> = ({ verticalLayout = false }) => {
    const t = useTranslations('homePage.promotion')
    const tFooter = useTranslations('footer')
    const tVariants = useTranslations('variants')
    const locale = useLocale()
    const brandName = tVariants(getBrandName())

    return (
        <MobileAppPromotion
            t={t}
            tFooter={tFooter}
            brandName={brandName}
            isRtl={locale === 'ar'}
            verticalLayout={verticalLayout}
        />
    )
}

export { MobileAppPromotionWrapper }
export default MobileAppPromotionWrapper
